import Axios from "axios";
import {
  SET_ACCOUNT_HEADS_LIST,
  UNSET_ACCOUNT_HEADS_LIST,
  SET_PAYMENT_ACCOUNT_HEADS_LIST,
  UNSET_PAYMENT_ACCOUNT_HEADS_LIST,
  SET_COST_CENTERS_LIST,
  UNSET_COST_CENTERS_LIST,
} from "@/store/mutation-types";
import {
  getAccountHeads,
  getPaymentAccountHeads,
  getCostCenters,
} from "@/store/api";

const state = {
  accountHeads: [],
  paymentAccountHeads: [],
  costCenters: [],
};

const getters = {
  getAccountHeads(state) {
    return state.accountHeads;
  },
  getPaymentAccountHeads(state) {
    return state.paymentAccountHeads;
  },
  getCostCenters(state) {
    return state.costCenters;
  },
};

const mutations = {
  [SET_ACCOUNT_HEADS_LIST](state, data) {
    state.accountHeads = data;
  },
  [UNSET_ACCOUNT_HEADS_LIST](state) {
    state.accountHeads = [];
  },
  [SET_PAYMENT_ACCOUNT_HEADS_LIST](state, data) {
    state.paymentAccountHeads = data;
  },
  [UNSET_PAYMENT_ACCOUNT_HEADS_LIST](state) {
    state.paymentAccountHeads = [];
  },
  [SET_COST_CENTERS_LIST](state, data) {
    state.costCenters = data;
  },
  [UNSET_COST_CENTERS_LIST](state) {
    state.costCenters = [];
  },
};

const actions = {
  getAccountHeads({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(getAccountHeads, { params })
        .then((response) => {
          commit(SET_ACCOUNT_HEADS_LIST, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_ACCOUNT_HEADS_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getPaymentAccountHeads({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(getPaymentAccountHeads, { params })
        .then((response) => {
          commit(SET_PAYMENT_ACCOUNT_HEADS_LIST, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_PAYMENT_ACCOUNT_HEADS_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getCostCenters({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(getCostCenters, { params })
        .then((response) => {
          commit(SET_COST_CENTERS_LIST, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_COST_CENTERS_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

